import { createSlice } from '@reduxjs/toolkit'
import car from '../../../assets/images/car.png'

const initialState = {
  cars: [
    {
      id: 1,
      brand: 'Ford',
      model: 'Fiesta',
      registration: 'AK18 BZL',
      year: 2012,
      engineSize: 1.6,
      fuelType: 'petrol',
      image: car,
      createdAt: '06 June at 9:32 am',
      owner: {
        id: 1,
        name: 'Alex',
      }
    },
    {
      id: 2,
      brand: 'Ford',
      model: 'Fiesta',
      registration: 'BAR1 987',
      year: 2012,
      engineSize: 1.6,
      fuelType: 'petrol',
      image: car,
      createdAt: '06 June at 9:32 am',
      owner: {
        id: 1,
        name: 'Alexa',
      }
    },
  ]

}

export const garageSlice = createSlice({
  name: "userGarage",
  initialState,
  reducers: {
    addCar: (state, action) => {
      state.cars = [...state.cars, {
        id: state.cars.length+1,
        image: car,
        ...action.payload
      }]
    },
  }
})

export const { addCar } = garageSlice.actions
export default garageSlice.reducer